import { DataObjectRepresentation } from '../../Model/DataObjectRepresentation';

export const HighGranularityCompactRepresentation =
    new DataObjectRepresentation({
        isCompact: true,
        granularity: 'high'
    });
